import { render, staticRenderFns } from "./unassigned.vue?vue&type=template&id=313e4918&"
import script from "./unassigned.vue?vue&type=script&lang=js&"
export * from "./unassigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports